import React, { SVGProps } from "react";

const SvgProtrusion02Dims = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={250}
    height={301}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 250 301"
    {...props}
  >
    <path
      d="M38.596 230.801V280l176.876-100.759v-35.346L131.051 108 38.596 230.801Z"
      fill="#BACBD8"
    />
    <path d="M38.594 241v39l-18.297-26.163L38.594 241Z" fill="#fff" />
    <path
      d="M2 247.184 35.386 266l99.779-152.046L2.605 39 2 247.184Z"
      fill="#45E0FF"
    />
    <path
      d="M95.522 192.843V227l28.462-16.843V176l-28.462 16.843ZM131.1 173.183V206l28.462-16.183V157L131.1 173.183Z"
      fill="#255D63"
    />
    <path
      d="M198.442 132.246 231.735 151l-96.53-37.294L3.015 39l195.427 93.246Z"
      fill="#2580B4"
    />
    <path
      d="M215.471 146v33.905L39.358 280l-12.961-18.344"
      stroke="#3F3F3F"
      strokeWidth={2}
    />
    <path d="M38.596 279v-20" stroke="#3F3F3F" />
    <path
      d="m2.606 39 132.559 74.954L35.386 266 2 247.184 2.606 39ZM3.016 39l195.426 93.246L231.735 151l-96.53-37.294"
      stroke="#002839"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="m142.281 110 54.893-32"
      stroke="#3B3B3B"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="m50.793 160 72.174-40"
      stroke="#000"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M10.133 35 66.042 2M59.941 5l131.133 76M71.124 299l-25.413-16M243.935 196 67.059 296M248.001 198l-27.446-14"
      stroke="#3B3B3B"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M165.964 246.328h1.568L171.708 257h-1.712l-1.104-2.976h-4.384L163.404 257h-1.616l4.176-10.672Zm2.464 6.4-1.728-4.688-1.744 4.688h3.472ZM127.232 25.328h3.616c.554 0 1.034.075 1.44.224.405.139.741.33 1.008.576.266.245.464.533.592.864.138.33.208.683.208 1.056 0 .341-.059.645-.176.912a2.936 2.936 0 0 1-.432.704 2.173 2.173 0 0 1-.576.464c-.203.117-.39.192-.56.224.213.032.453.101.72.208.266.096.517.245.752.448.234.203.432.47.592.8.16.32.24.72.24 1.2 0 .576-.107 1.056-.32 1.44a2.492 2.492 0 0 1-.848.912 3.45 3.45 0 0 1-1.264.496 8.167 8.167 0 0 1-1.568.144h-3.424V25.328Zm3.344 9.344c.277 0 .565-.016.864-.048.298-.032.57-.107.816-.224.256-.117.464-.288.624-.512.16-.235.24-.555.24-.96 0-.384-.08-.693-.24-.928a1.665 1.665 0 0 0-.592-.56 2.144 2.144 0 0 0-.784-.272 4.578 4.578 0 0 0-.832-.08h-1.952v3.584h1.856Zm.048-4.896c.234 0 .469-.027.704-.08.234-.064.448-.16.64-.288.192-.128.346-.293.464-.496a1.45 1.45 0 0 0 .176-.736c0-.32-.059-.576-.176-.768a1.216 1.216 0 0 0-.464-.464 1.641 1.641 0 0 0-.64-.224 3.933 3.933 0 0 0-.704-.064h-1.904v3.12h1.904Z"
      fill="#3B3B3B"
    />
    <path
      d="M191.074 75v11M67.059 291v9M243.934 190v10M59.941 1v9"
      stroke="#3B3B3B"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="m69.092 206 15.248-7M50.793 152l14.231 7"
      stroke="#000"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M49.976 181.328h3.376c.725 0 1.322.101 1.792.304.48.203.858.459 1.136.768.288.309.485.656.592 1.04.117.384.176.757.176 1.12 0 .533-.09 1.003-.272 1.408a2.905 2.905 0 0 1-.752 1.024 3.3 3.3 0 0 1-1.152.608 4.735 4.735 0 0 1-1.44.208h-1.936V192h-1.52v-10.672Zm3.44 5.168c.661 0 1.168-.165 1.52-.496.362-.341.544-.811.544-1.408 0-.608-.187-1.083-.56-1.424-.363-.352-.864-.528-1.504-.528h-1.92v3.856h1.92Z"
      fill="#000"
    />
    <path
      d="M57.916 157a85.194 85.194 0 0 0 .753 12.492c2.106 15.333 8.393 26.623 17.537 33.508"
      stroke="#000"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

export default SvgProtrusion02Dims;
